/*
 * Dante Furniture – smart callback times for the Klaviyo "Call Back Request" form (Sa84Fz)
 *
 * - Hides callback options that can't be honoured right now (UK time):
 *     • "Today" slots that have passed or start in < 30 mins
 *     • "As soon as possible" outside call hours
 *     • "Tomorrow" when tomorrow is Sunday; "Monday" except on Saturdays
 * - Stops a stale choice being sent if the page was left open past the slot
 * - Saves the real callback date, product and page to the Klaviyo profile
 *
 * Call hours: Mon–Sat, 9:00am–5:30pm. Edit SETTINGS below if they change.
 */
(function () {
  'use strict';

  var SETTINGS = {
    formId: 'Sa84Fz',
    openDays: [1, 2, 3, 4, 5, 6], // 0 = Sun … 6 = Sat
    open: 9 * 60,                 // 9:00am (minutes after midnight)
    close: 17 * 60 + 30,          // 5:30pm
    lead: 30                      // minutes notice needed for a "today" slot
  };

  var DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var SEL = '.klaviyo-form-' + SETTINGS.formId;

  /* ---------- UK clock ---------- */
  function ukNow() {
    if (window.__dfCallbackNow) return window.__dfCallbackNow; // test hook
    var p = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London', year: 'numeric', month: 'numeric', day: 'numeric',
      hour: 'numeric', minute: 'numeric', hourCycle: 'h23'
    }).formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    var y = +p.year, m = +p.month, d = +p.day;
    return { y: y, m: m, d: d, dow: new Date(Date.UTC(y, m - 1, d)).getUTCDay(), mins: (+p.hour % 24) * 60 + (+p.minute) };
  }

  function addDays(now, n) {
    var dt = new Date(Date.UTC(now.y, now.m - 1, now.d + n));
    return { y: dt.getUTCFullYear(), m: dt.getUTCMonth() + 1, d: dt.getUTCDate(), dow: dt.getUTCDay() };
  }

  function isOpenDay(dow) { return SETTINGS.openDays.indexOf(dow) > -1; }

  function nextOpenOffset(now) { // days until the next open day after today
    for (var i = 1; i <= 7; i++) if (isOpenDay((now.dow + i) % 7)) return i;
    return 1;
  }

  /* ---------- Read an option label ---------- */
  function parseTimes(text) {
    var re = /(\d{1,2})(?:[:.](\d{2}))?\s*(am|pm)/gi, out = [], m;
    while ((m = re.exec(text))) {
      var h = +m[1] % 12 + (m[3].toLowerCase() === 'pm' ? 12 : 0);
      out.push(h * 60 + (+m[2] || 0));
    }
    return out;
  }

  function classify(label) {
    var t = String(label || '').trim().toLowerCase();
    var times = parseTimes(t);
    var slot = { start: times.length ? times[0] : SETTINGS.open, end: times.length ? times[times.length - 1] : SETTINGS.close };
    if (t.indexOf('as soon as possible') > -1 || t.indexOf('asap') === 0) return { kind: 'asap' };
    if (/^today/.test(t)) return { kind: 'day', offset: 0, start: slot.start, end: slot.end };
    if (/^tomorrow/.test(t)) return { kind: 'day', offset: 1, start: slot.start, end: slot.end };
    for (var i = 0; i < 7; i++) {
      if (t.indexOf(DAY_NAMES[i].toLowerCase()) === 0) return { kind: 'weekday', dow: i, start: slot.start, end: slot.end };
    }
    return { kind: 'other' };
  }

  function weekdayOffset(c, now) { // days until the next occurrence of c.dow (never today)
    var n = (c.dow - now.dow + 7) % 7;
    return n === 0 ? 7 : n;
  }

  function isAvailable(c, now) {
    switch (c.kind) {
      case 'asap':
        return isOpenDay(now.dow) && now.mins >= SETTINGS.open && now.mins <= SETTINGS.close - SETTINGS.lead;
      case 'day':
        if (c.offset === 0) return isOpenDay(now.dow) && now.mins <= c.end - SETTINGS.lead;
        return isOpenDay(addDays(now, c.offset).dow);
      case 'weekday':
        // Only offer a named day when it's the next open day and isn't "tomorrow" (e.g. Monday on a Saturday)
        var off = weekdayOffset(c, now);
        return isOpenDay(c.dow) && off > 1 && off === nextOpenOffset(now);
      default:
        return true;
    }
  }

  /* ---------- Human-readable due date for staff ---------- */
  function fmtTime(mins) {
    var h = Math.floor(mins / 60), m = mins % 60, ap = h >= 12 ? 'pm' : 'am';
    h = h % 12 || 12;
    return h + (m ? ':' + (m < 10 ? '0' : '') + m : '') + ap;
  }
  function fmtDate(d) { return DAY_NAMES[d.dow] + ' ' + d.d + ' ' + MONTHS[d.m - 1] + ' ' + d.y; }

  function describeDue(label, now) {
    var c = classify(label);
    if (c.kind === 'asap') return fmtDate(now) + ', ASAP (by ' + fmtTime(Math.min(now.mins + 30, SETTINGS.close)) + ')';
    if (c.kind === 'day') return fmtDate(addDays(now, c.offset)) + ', ' + fmtTime(c.start) + ' – ' + fmtTime(c.end);
    if (c.kind === 'weekday') return fmtDate(addDays(now, weekdayOffset(c, now))) + ', ' + fmtTime(c.start) + ' – ' + fmtTime(c.end);
    return label;
  }

  /* ---------- Browser wiring ---------- */
  if (typeof document === 'undefined') {
    if (typeof module !== 'undefined') module.exports = { classify: classify, isAvailable: isAvailable, describeDue: describeDue, SETTINGS: SETTINGS };
    return;
  }

  function filterOptions(root) {
    var opts = root.querySelectorAll('[role="option"]');
    if (!opts.length) return;
    var now = ukNow();
    for (var i = 0; i < opts.length; i++) {
      var ok = isAvailable(classify(opts[i].textContent), now);
      opts[i].style.display = ok ? '' : 'none';
      opts[i].setAttribute('aria-disabled', ok ? 'false' : 'true');
    }
  }

  var watched = typeof WeakSet !== 'undefined' ? new WeakSet() : null;
  function watch(root) {
    if (!watched || watched.has(root)) return;
    watched.add(root);
    new MutationObserver(function () { filterOptions(root); }).observe(root, { childList: true, subtree: true });
    filterOptions(root);
  }

  var queued = false;
  function scan() {
    queued = false;
    var roots = document.querySelectorAll(SEL);
    for (var i = 0; i < roots.length; i++) watch(roots[i]);
  }
  function queueScan() { if (!queued) { queued = true; setTimeout(scan, 50); } }

  function showError(root, input, msg) {
    var el = root.querySelector('[data-df-callback-msg]');
    if (!el) {
      el = document.createElement('div');
      el.setAttribute('data-df-callback-msg', '');
      el.setAttribute('role', 'alert');
      el.style.cssText = 'color:#c00;font:14px/1.4 Arial,Helvetica,sans-serif;margin:6px 6px 0;';
      var host = input.closest('.klaviyo-dropdown') || input.parentElement.parentElement;
      host.appendChild(el);
    }
    el.textContent = msg;
    el.hidden = false;
    setTimeout(function () { el.hidden = true; }, 8000);
  }

  function guard(e) {
    var root = e.target && e.target.closest && e.target.closest(SEL);
    if (!root) return;
    if (e.type === 'click') {
      var btn = e.target.closest('button, input[type="submit"]');
      if (!btn || !/call me back|submit/i.test(btn.textContent + ' ' + (btn.value || ''))) return;
    }
    var input = root.querySelector('input[role="combobox"]');
    if (!input || !input.value) return;
    if (!isAvailable(classify(input.value), ukNow())) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      showError(root, input, 'Sorry, that time has now passed – please choose another callback time.');
      input.focus();
    }
  }

  function productContext(root) {
    var props = { 'Callback Page': location.origin + location.pathname };
    var form = root && root.querySelector('form');
    var title = form && form.querySelector('input[name="product_title"]');
    var price = form && form.querySelector('input[name="variant_price"]');
    var og = document.querySelector('meta[property="og:title"]');
    if (title && title.value) props['Callback Product'] = title.value;
    else if (/\/products\//.test(location.pathname) && og) props['Callback Product'] = og.content;
    if (price && price.value) props['Callback Product Price'] = price.value;
    return props;
  }

  window.addEventListener('klaviyoForms', function (e) {
    var d = e.detail || {};
    if (d.type !== 'submit' || d.formId !== SETTINGS.formId) return;
    var md = d.metaData || {};
    var now = ukNow();
    var props = productContext(document.querySelector(SEL));
    if (md['Callback Time']) props['Callback Due'] = describeDue(md['Callback Time'], now);
    props['Callback Requested At'] = fmtDate(now) + ', ' + fmtTime(now.mins);
    if (md.$phone_number) props.$phone_number = md.$phone_number;
    try {
      if (window.klaviyo && typeof window.klaviyo.identify === 'function') window.klaviyo.identify(props);
      else (window._learnq = window._learnq || []).push(['identify', props]);
    } catch (err) { /* never block the form */ }
  });

  document.addEventListener('click', guard, true);
  document.addEventListener('submit', guard, true);
  document.addEventListener('focusin', function (e) { // re-check if the page has been open a while
    var root = e.target && e.target.closest && e.target.closest(SEL);
    if (root) filterOptions(root);
  }, true);

  scan();
  new MutationObserver(queueScan).observe(document.documentElement, { childList: true, subtree: true });

  window.dfCallbackSlots = { classify: classify, isAvailable: isAvailable, describeDue: describeDue, refresh: scan };
})();
